/* Footer.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { ClearSelectionButton } from '../ClearSelectionButton';
const footerWrapperStyles = xcss({
  borderTopColor: 'color.border',
  borderTopWidth: 'border.width',
  borderTopStyle: 'solid'
});
export const Footer = _ref => {
  let {
    isClearSelectionDisabled,
    onClearSelection
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: footerWrapperStyles
  }, /*#__PURE__*/React.createElement(ClearSelectionButton, {
    onClick: onClearSelection,
    isDisabled: isClearSelectionDisabled
  }));
};